var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("share-button", {
    attrs: {
      openShareCb: _vm.openShare,
      color: _vm.color,
      classes: _vm.classes
    }
  })
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d7e99046", { render: render, staticRenderFns: staticRenderFns })
  }
}